module.exports = __webpack_public_path__ + "static/media/scribe.6f4743a6.png";